import { AddShippingOrderAddressArgs } from 'types/api/arguments/add-shipping-order-address-args'

export const addShippingOrderAddressArgsToParams = ({
  addressId,
}: AddShippingOrderAddressArgs) => ({
  address_id: addressId,
})
